import * as ATCInterstitialActionTypes from '../actionTypes/ATCInterstitialActionTypes';

export const setATCAddEdit = () => ({
    type: ATCInterstitialActionTypes.SET_ADD_EDIT,
});

export const ResetATCAddEdit = () => ({
    type: ATCInterstitialActionTypes.RESET_ADD_EDIT,
});
